import { faPenToSquare, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axiosInstance from './axiosInstance'
import PaginationBar from '../components/common/PaginationBar';

function ConfigList() {
  const [configList, setConfigList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [domainFilter, setDomainFilter] = useState(() => {
    // Load saved domain from localStorage or default to "all"
    return localStorage.getItem('configDomainFilter') || "all";
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [domainList, setDomainList] = useState([]);

  useEffect(() => {
    getConfigList().then(r => {});
    fetchDomainList().then(r => {});
  }, []);

  let getConfigList = async () => {
    try {
      const res = await axiosInstance.get("/config/list");
      setConfigList(res.data?.data?.items ?? []);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchDomainList = async () => {
    try {
      const response = await axiosInstance.get("/domains/list");
      const domains = response.data?.data || [];
      setDomainList(domains);
      console.log(domains);
    } catch (error) {
      console.error('Error fetching domain list:', error);
      setDomainList([]);
    }
  };

  const handleDomainFilterChange = (value) => {
    setDomainFilter(value);
    // Save the selected domain to localStorage
    localStorage.setItem('configDomainFilter', value);
  };

  let handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure do you want to delete the data?");
      if (confirmDelete) {
        await axiosInstance.post(`/config/delete/${id}`);
        await getConfigList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const filteredList = configList.filter(config =>
    (filterText === "" || config?.code.toLowerCase().includes(filterText.toLowerCase())) &&
    (domainFilter === "all" || config?.domain === domainFilter)
  );

// Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
      <>
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Config List</h1>
          <div className="align-items-end">
            <Link to="/portal/create-config" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <FontAwesomeIcon icon={faPlus} className="creating-config mr-2" />
              Create Config
            </Link>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="mb-3 col-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Name"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <select
                    className="form-control"
                    value={domainFilter}
                    onChange={(e) => handleDomainFilterChange(e.target.value)}
                >
                    <option value="all">All Domains</option>
                    {domainList.map((domain) => (
                      <option key={domain.id || domain.code} value={domain.code}>
                        {domain.code === 'cre8ive' ? `${domain.code} (tattoo)` : domain.code}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {
              isLoading ? <img src='https://media.giphy.com/media/ZO9b1ntYVJmjZlsWlm/giphy.gif' alt="Loading" />
                  : <div className="table-responsive">
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                      <thead>
                      <tr>
                        <th>Id</th>
                        <th>Code</th>
                        <th>Main Service</th>
                        <th>Backup Service</th>
                        <th>Backup Service Countries</th>
                        <th>Disable Countries</th>
                        <th>Domain</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tfoot>
                      <tr>
                        <th>Id</th>
                        <th>Code</th>
                        <th>Main Service</th>
                        <th>Backup Service</th>
                        <th>Backup Service Countries</th>
                        <th>Disable Countries</th>
                        <th>Domain</th>
                        <th>Action</th>
                      </tr>
                      </tfoot>
                      <tbody>
                      {currentItems.map((config) => {
                        const code = config?.code;
                        return (
                            <tr key={config.id}>
                              <td>{config.id}</td>
                              <td>{code}</td>
                              <td>{config?.main_service}</td>
                              <td>{config?.backup_service}</td>
                              <td>{config?.backup_service_countries}</td>
                              <td>{config?.disable_countries === 'null' ? '' : config?.disable_countries}</td>
                              <td>{config?.domain === 'cre8ive' ? `${config?.domain} (tattoo)` : config?.domain}</td>
                              <th>
                                <Link to={`/portal/config-edit/${config.id}`} className='btn btn-outline-primary btn-sm mr-1'><FontAwesomeIcon icon={faPenToSquare} /> Edit</Link>
                                <button onClick={() => handleDelete(config.id)} className='btn btn-danger btn-sm mr-1'><FontAwesomeIcon icon={faTrash} /> Delete</button>
                              </th>
                            </tr>
                        )
                      })}
                      </tbody>
                    </table>
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                  </div>
            }
          </div>
        </div>
      </>
  )
}

export default ConfigList
